define([
	"dojo/_base/declare",
	"csi/action/NewFromController",
	"csi/table/NewMixin"
], function(declare,NewFromController,NewMixin) {

	return declare([NewFromController, NewMixin], {
		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			return this.getMovedNodes();
		},

		preProcess: function() {
			// summary: call mixin before continuing
			if (this._newPreProcess()) {
				this.inherited(arguments);
			}
		},

		postProcessSuccess: function() {
			// summary: call mixin if no action-specific post processing
			return this.inherited(arguments) || this._newPostProcess(); 
		}
	});
});